if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      const cartNotification = document.querySelector('cart-notification');
      const cartDrawer = document.querySelector('cart-drawer');

      const suppressCartNotification =
        this.dataset.suppressCartNotification === 'true' ||
        this.closest('cart-drawer') ||
        this.closest('#CartDrawer') ||
        this.closest('.wbcartupsell');

      // Prefer cart drawer when it exists (cart_type == drawer). Otherwise fallback to cart-notification.
      // This also avoids updating only the notification while the drawer list stays stale.
      if (cartDrawer) {
        this.cart = cartDrawer;
      } else {
        this.cart = cartNotification;
      }
      if (suppressCartNotification && cartDrawer) this.cart = cartDrawer;

      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    getWebiMiniCartSectionId() {
      const el = document.getElementById('webi-main-cart-items');
      return el?.dataset?.id || null;
    }

    renderWebiMiniCart(parsedState) {
      const sectionId = this.getWebiMiniCartSectionId();
      if (!sectionId) return;
      if (!parsedState?.sections || !parsedState.sections[sectionId]) return;

      const sectionHTML = parsedState.sections[sectionId];
      const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');

      const replaceFromTo = (selector) => {
        const next = doc.querySelector(selector);
        const current = document.querySelector(selector);
        if (next && current) current.innerHTML = next.innerHTML;
      };

      // These containers live inside the header section (Webibazaar dropdown).
      replaceFromTo('#webi-main-cart-items .js-contents');
      replaceFromTo('#webi-main-cart-footer .js-contents');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // Ask Shopify to return all the sections we need to refresh (drawer/notification + Webibazaar mini-cart).
      const sectionIds = [];
      if (this.cart?.getSectionsToRender) {
        sectionIds.push(...this.cart.getSectionsToRender().map((section) => section.id));
      }
      const webiSectionId = this.getWebiMiniCartSectionId();
      if (webiSectionId) sectionIds.push(webiSectionId);

      if (sectionIds.length) {
        formData.append('sections', [...new Set(sectionIds)]);
        formData.append('sections_url', window.location.pathname);
      }
      if (this.cart?.setActiveElement) this.cart.setActiveElement(document.activeElement);

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart && !this.getWebiMiniCartSectionId()) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;

          // Keep Webibazaar dropdown mini-cart in sync (it lives inside the header section).
          this.renderWebiMiniCart(response);

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.cart?.renderContents) this.cart.renderContents(response);
          }
          if ($('.mfp-ready').length) { // Close Quickview Modal
             $.magnificPopup.close();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
